/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ConstructionStatus } from '../models/ConstructionStatus';
import type { PaginatedConstructionStatusList } from '../models/PaginatedConstructionStatusList';
import type { PatchedConstructionStatus } from '../models/PatchedConstructionStatus';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class ClientsConstructionStatusService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns PaginatedConstructionStatusList
     * @throws ApiError
     */
    public clientsConstructionStatusList({
        page,
        pageSize,
    }: {
        /**
         * A page number within the paginated result set.
         */
        page?: number,
        /**
         * Number of results to return per page.
         */
        pageSize?: number,
    }): CancelablePromise<PaginatedConstructionStatusList> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clients-construction-status/',
            query: {
                'page': page,
                'page_size': pageSize,
            },
        });
    }

    /**
     * @returns ConstructionStatus
     * @throws ApiError
     */
    public clientsConstructionStatusCreate({
        requestBody,
    }: {
        requestBody: ConstructionStatus,
    }): CancelablePromise<ConstructionStatus> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clients-construction-status/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns ConstructionStatus
     * @throws ApiError
     */
    public clientsConstructionStatusRetrieve({
        id,
    }: {
        /**
         * A unique integer value identifying this construction status.
         */
        id: number,
    }): CancelablePromise<ConstructionStatus> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clients-construction-status/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns ConstructionStatus
     * @throws ApiError
     */
    public clientsConstructionStatusUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this construction status.
         */
        id: number,
        requestBody: ConstructionStatus,
    }): CancelablePromise<ConstructionStatus> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/clients-construction-status/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns ConstructionStatus
     * @throws ApiError
     */
    public clientsConstructionStatusPartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this construction status.
         */
        id: number,
        requestBody?: PatchedConstructionStatus,
    }): CancelablePromise<ConstructionStatus> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/clients-construction-status/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public clientsConstructionStatusDestroy({
        id,
    }: {
        /**
         * A unique integer value identifying this construction status.
         */
        id: number,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/clients-construction-status/{id}/',
            path: {
                'id': id,
            },
        });
    }

}
